import React from "react";
import {
  BsFileEarmarkPost,
  BsFillChatDotsFill,
  BsFillCalendarEventFill,
  BsEmojiHeartEyesFill,
  BsQuestionDiamondFill,
} from "react-icons/bs";

import { SiFandango } from "react-icons/si";

import { AiFillAudio } from "react-icons/ai";
import { FaChalkboardTeacher } from "react-icons/fa";
import CardSchedule from "../Reuse/CardSchedule";
import StarShowcase from "./StarShowcase";

const Schedule = () => {
  return (
    <>
      <div className="row">
        <CardSchedule
          link={"/superstar-admin/schedule/single"}
          title={"Simple-Post"}
          icon={<BsFileEarmarkPost size={50} />}
        />
        <CardSchedule
          link={"/superstar-admin/schedule/single"}
          title={"Audition"}
          icon={<AiFillAudio size={50} />}
        />
        <CardSchedule
          link={"/superstar-admin/schedule/single"}
          title={"Live-Chat"}
          icon={<BsFillChatDotsFill size={50} />}
        />
        <CardSchedule
          link={"/superstar-admin/schedule/single"}
          title={"Meetup-Event"}
          icon={<BsFillCalendarEventFill size={50} />}
        />
        <CardSchedule
          link={"/superstar-admin/schedule/single"}
          title={"Learning-Session"}
          icon={<BsEmojiHeartEyesFill size={50} />}
        />
        <CardSchedule
          link={"/superstar-admin/schedule/single"}
          title={"Greeting"}
          icon={<FaChalkboardTeacher size={50} />}
        />
        <CardSchedule
          link={"/superstar-admin/star-showcase"}
          title={"Star-Showcase"}
          icon={<FaChalkboardTeacher size={50} />}
        />
        <CardSchedule
          link={"/superstar-admin/schedule/single"}
          title={"Fan-Group"}
          icon={<SiFandango size={50} />}
        />
        <CardSchedule
          link={"/superstar-admin/schedule/single"}
          title={"Q&A"}
          icon={<BsQuestionDiamondFill size={50} />}
        />
      </div>
    </>
  );
};

export default Schedule;
